import { render, staticRenderFns } from "./editCover.vue?vue&type=template&id=b8d28ebe&scoped=true&"
import script from "./editCover.vue?vue&type=script&lang=js&"
export * from "./editCover.vue?vue&type=script&lang=js&"
import style0 from "./editCover.vue?vue&type=style&index=0&id=b8d28ebe&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d28ebe",
  null
  
)

export default component.exports